module.exports = __webpack_public_path__ + "static/media/wssNewLogo.3f9c62de.png";